import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useUserAdminStore = create(persist(
    (set) => ({
        userAdmin: {
            error: false,
            login: false,
            id_user: '',
            name_user: '',
            email_user: '',
            token_user: '',
            tipo_user: '',
            token_exp_user: '',
            errorMsg: ''
        },
        updateUserAdmin: (userData) => set(() => ({ 
            userAdmin: {
                error: false,
                login: true,
                id_user: userData.id_user,
                name_user: userData.name_user,
                email_user: userData.email_user,
                token_user: userData.token_user,
                tipo_user: userData.tipo_user,
                token_exp_user: userData.token_exp_user,
                errorMsg: ''
            }
        })),
        setError: (errorMessage) => set(() => ({
            userAdmin: {
                error: true,
                login: false,
                id_user: '',
                name_user: '',
                email_user: '',
                token_user: '',
                tipo_user: '',
                token_exp_user: '',
                errorMsg: errorMessage
            }
        })),
        logout: () => set(() => ({
            userAdmin: {
                error: false,
                login: false,
                id_user: '',
                name_user: '',
                email_user: '',
                token_user: '',
                tipo_user: '',
                token_exp_user: '',
                errorMsg: ''
            }
        })),
    }), 
    {
        name: 'userAdmin',
        storage: createJSONStorage(() => sessionStorage)
    }
));